// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase, ref, set, get, update} from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBeSUIQQbRSEHcbR-GfDW8hQYOBbPrbhOI",
  authDomain: "handcricket-7498f.firebaseapp.com",
  databaseURL: "https://handcricket-7498f-default-rtdb.firebaseio.com",
  projectId: "handcricket-7498f",
  storageBucket: "handcricket-7498f.firebasestorage.app",
  messagingSenderId: "119955873739",
  appId: "1:119955873739:web:456cc81a1cd08d309de04e",
  measurementId: "G-8QW4F4CY9N"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getDatabase(app);

export { db, ref, set, get, update };